module.exports = __webpack_public_path__ + "static/media/l-md9.36292876.png";